module.exports = __webpack_public_path__ + "img/card_ip_stipulation43.d82c58a1.svg";